<template>
  <div class="ui-involved-member-wrapper" v-html="richText"></div>
</template>

<script>
import resolveRichText from "@/utils/resolveRichText"

export default {
  name: "uiInvolvedMember",
  props: {
    involvedMember: {
      type: String,
      default: ""
    }
  },
  computed: {
    richText() {
      return resolveRichText(this.involvedMember)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-involved-member-wrapper {
  opacity: 0.5;
  text-align: center;
  margin: 0.4rem 0 0.2rem;
}
.pc .ui-involved-member-wrapper {
  margin: 40px 0 20px;
}
</style>
